import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Admin from '../views/Admin'
import Login from '../views/Login'
import A00000 from '../views/A00000'
import Q01005 from '../views/Q01005'
import Q01010 from '../views/Q01010'
import Q01020 from '../views/Q01020'
import Q01030 from '../views/Q01030'
import Q02010 from '../views/Q02010'
import Q02020 from '../views/Q02020'
import Q03010 from '../views/Q03010'
import Q03020 from '../views/Q03020'
import S00020 from '../views/S00020'
import S00030 from '../views/S00030'
import S00050 from '../views/S00050'
import S00110 from '../views/S00110'
import S00120 from '../views/S00120'
import Loading from '../views/Loading'

// 將 VueRouter 注入 Vue
Vue.use(VueRouter)

const routes = [
  // config <router-view /> under App.vue
  { path: '/Login', name: 'Login', component: Login },
  { path: '/Loading', name: 'Loading', component: Loading },
  // config <router-view /> under component Admin
  {
    path: '/',
    name: 'Admin',
    component: Admin,
    children: [
      { path: '', name: 'A00000', component: A00000 },
      { path: 'Q01005', name: 'Q01005', component: Q01005 },
      { path: 'Q01010', name: 'Q01010', component: Q01010 },
      { path: 'Q01020', name: 'Q01020', component: Q01020 },
      { path: 'Q01030', name: 'Q01030', component: Q01030 },
      { path: 'Q02010', name: 'Q02010', component: Q02010 },
      { path: 'Q02020', name: 'Q02020', component: Q02020 },
      { path: 'Q03010', name: 'Q03010', component: Q03010 },
      { path: 'Q03020', name: 'Q03020', component: Q03020 },
      { path: 'S00020', name: 'S00020', component: S00020 },
      { path: 'S00030', name: 'S00030', component: S00030 },
      { path: 'S00050', name: 'S00050', component: S00050 },
      { path: 'S00110', name: 'S00110', component: S00110 },
      { path: 'S00120', name: 'S00120', component: S00120 }
    ]
  }
]
let zhConfig = require('../../zh.config')
const isIISSubApp = zhConfig.isIISSubApp
const IISSubAppRoute = zhConfig.IISSubAppRoute
const loginMode = zhConfig.loginMode
const base =
  process.env.NODE_ENV === 'production'
    ? isIISSubApp
      ? '/' + IISSubAppRoute + '/admin'
      : '/admin'
    : '/'
// 按照 loginMode 注入 loginRouter
window.console.log('loginMode:' + loginMode)
const loginRouter = require('../mode/' + loginMode + '/router').default.loginRouter

// 根據註冊的 routes 建立 VueRouter
const router = new VueRouter({
  mode: 'history',
  // 預設是  '/'，放在 subpath /admin 下就要設置  /admin
  // base: process.env.BASE_URL,
  base,
  routes
})

router.beforeEach(async (to, from, next) => {
  try {
    // 登入驗證：如果不是在 Login 且使用者沒有登入，就導到 Login 頁面
    // RBAC：如果 to.name 不在可存取的清單中就回上一頁
    // P.S. next({name: to.name})，當會造成無窮迴圈(觸發下一個 to.name 的 beforeEach 判斷)

    let isLogin = store.state.user.isLogin

    // 處理 Login
    if (to.name !== 'Login' && !isLogin) {
      // 先出現 Loading 畫面
      if (to.name !== 'Loading') {
        next({ name: 'Loading' })
      }
      // 再執行注入的 loginRouter 邏輯
      loginRouter(to, from, next)
      // 解除登入導到  Login 的情況
    } else if (to.name === 'Login' && !isLogin) {
      next()
      // 已登入仍進入 Login 的情況
    } else if (to.name === 'Login' && isLogin) {
      next({ name: 'Admin' })
      // 其他嘗試進入 menusId 沒有的頁面一律回導 // 單獨處理 Admin、A00000，因為這兩個不在 menusId 裡面
    } else if (
      !store.state.menusId.includes(to.name) &&
      !['Admin', 'A00000'].includes(to.name)
    ) {
      next({ name: from.name })
      // 其餘放行
    } else {
      next()
    }
  } catch (err) {
    window.console.error(err.toString())
  }
})

export default router
